import { render, staticRenderFns } from "./CardLoyaltyBox.vue?vue&type=template&id=d5f9b906&"
import script from "./CardLoyaltyBox.vue?vue&type=script&lang=js&"
export * from "./CardLoyaltyBox.vue?vue&type=script&lang=js&"
import style0 from "./CardLoyaltyBox.vue?vue&type=style&index=0&id=d5f9b906&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardLoyalty: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/CardLoyalty.vue').default})
